import React from 'react'

// GraphQL
import { useQuery } from '@apollo/client'
import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      onQueryError, // via withQueryResults
      onLoggedInQueryCompleted
    } = props

    // react hooks
    const { loading, data } = useQuery(query, {
      onError: onQueryError,
      onCompleted: onLoggedInQueryCompleted
    })

    // GraphQL data
    const { viewer: account, seasons } = data || {}
    const season = seasons ? seasons[0] : null

    return (
      <WrappedComponent
        loading={loading}
        account={account}
        season={season}
        {...props}
      />
    )
  }
}

export default withQuery
